import { gql, useQuery } from '@zenbusiness/application-commons-graphql';
import { useError } from '@zenbusiness/application-commons-logging';

export const PRODUCT_CATEGORIES_QUERY = gql`
  query productCategories {
    productCategories {
      uuid
      titleKey
      rank
      isActive
      descriptionKey
      imagePath
    }
  }
`;

export function useProductCategories() {
  const { data, loading, error, refetch } = useQuery(PRODUCT_CATEGORIES_QUERY, {
    noThrow: true,
    useCache: false,
  });

  useError(error);

  return {
    data: data?.productCategories,
    error,
    loading,
    refetch,
  };
}
